import { Link, useNavigate } from 'react-router-dom';
import { APP_NAME } from '../../config/branding.js';
import { menu, defaultRoute, NOT_FOUND_ROUTE } from '../../config/menuData.js';

/**
 * Shared presentation for the generic 401 / 403 / 404 / 500 status pages.
 *
 * These are not in the raw design — they are the standard chrome every app needs
 * — so they are themed entirely from the project's design tokens
 * (src/scss/_design-tokens.scss) and branding, and rendered inside the app's
 * layout, so they never look bolted on.
 */
export default function StatusPage({ code, title, message, icon, tone = 'primary', actions }) {
  const navigate = useNavigate();
  const home = defaultRoute();
  // Only offer the landing link once the landing page actually exists — until
  // then it would resolve to this very page.
  const homeAvailable = home !== NOT_FOUND_ROUTE;

  return (
    <div className="status-page container" role="alert">
      <div className="card glass-panel text-center mx-auto" style={{ maxWidth: '34rem' }}>
        <div className="card-body p-4 p-md-5">
          <i className={`${icon} status-page__icon text-${tone} mb-3 d-block`} aria-hidden="true" />
          <p className="status-page__code text-gradient mb-1">{code}</p>
          <h1 className="h4 card-title mb-3">{title}</h1>
          <p className="text-body-secondary mb-4">{message}</p>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            {actions}
            {homeAvailable ? (
              <Link className="btn btn-primary" to={home}>
                <i className="fa fa-th-large me-2" aria-hidden="true" />
                Go to {menu.defaultMenuItem.label}
              </Link>
            ) : null}
            <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
              <i className="fa fa-arrow-left me-2" aria-hidden="true" />
              Go back
            </button>
          </div>
        </div>
        <div className="card-footer text-body-secondary small">{APP_NAME}</div>
      </div>
    </div>
  );
}
